"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _formGroup = _interopRequireDefault(require("../core/form-group"));
var _label = _interopRequireDefault(require("../core/label"));
var _col = _interopRequireDefault(require("../core/col"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Input = require("../core/input").default;
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "Line 1");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Line 2");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "City");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Post Code");
class AddressEditor extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onChange", (value, field) => {
      this.props.onChange({
        ...this.props.value,
        [field.split('.').pop()]: value
      }, this.props.name);
    });
  }
  render() {
    const base = this.props.name + '.';
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(Input, {
      type: "text",
      name: base + 'line1',
      value: this.props.value.line1,
      onChange: this._onChange,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(Input, {
      type: "text",
      name: base + 'line2',
      value: this.props.value.line2,
      onChange: this._onChange,
      required: false
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(Input, {
      type: "text",
      name: base + 'city',
      value: this.props.value.city,
      onChange: this._onChange,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(Input, {
      type: "text",
      name: base + 'postCode',
      value: this.props.value.postCode,
      onChange: this._onChange,
      required: true
    }))));
  }
}
var _default = exports.default = AddressEditor;